export const PersonaCreationTypes = {
    CREATE_BULK: 0,
    CREATE_SINGLE: 1,
    UPLOAD_ZIP_FILE: 2,
    UPLOAD_SKILLS_EXCEL: 3,
    UPLOAD_ROLES_SKILLS_EXCEL: 4,
    UPLOAD_FROM_HRMS: 5
};
